<script setup lang="ts" generic="T extends Record<string, any> | undefined = undefined">
import { ref, watch } from 'vue';
import type { PopupEvent } from '../popup/types';
import type { Emits, Props } from './types';
import TopButton from '@/components/forms/button/button.vue';
import TopPopup from '../popup/popup.vue';
import TopPopupWidgetInput from '../popup/widgetInput/widgetInput.vue';

const props = defineProps<Props<T>>();

const emit = defineEmits<Emits<T>>();

const reset = () => localValue.value = props.defaultValue ?? '';

const isSubmit = ref(false);

const localValue = ref();
watch(() => props.defaultValue, () => reset(), { immediate: true });

const onSubmit = () => {
	isSubmit.value = true;
};

const onClose = (popupEvent: PopupEvent<T>) => {
	if (isSubmit.value) {
		isSubmit.value = false;

		emit('submit', localValue.value);

		reset();

		return;
	}

	reset();

	emit('close', popupEvent);
};

// сужение объекта для propsPopup
const {
	submitText,
	cancelText,
	defaultValue,
	...propsPopup
}: Props<T> = props;
</script>

<template>
	<!-- @vue-generic {T} -->
	<TopPopup
		class="top-popupPrompt"
		:=propsPopup
		@open="$emit('open', $event)"
		@close="onClose($event)"
		@scrollContentList="(...args) => $emit('scrollContentList', ...args)"
	>
		<template #opener>
			<!-- @slot Элемент для открытия TopPopup -->
			<slot name="opener"></slot>
		</template>

		<template #header v-if="$slots.header">
			<!-- @slot Шапка -->
			<slot name="header"></slot>
		</template>

		<template #content v-if="$slots.default">
			<!-- @slot Контент в свободной форме -->
			<slot></slot>

			<TopPopupWidgetInput v-model.trim="localValue"/>
		</template>

		<template #footer>
			<!-- @slot Футер -->
			<slot name="footer"></slot>

			<TopButton color="theme">
				{{ cancelText || $i18n.Common.Cancel }}
			</TopButton>

			<TopButton @click="onSubmit">
				{{ submitText || $i18n.Common.OK }}
			</TopButton>
		</template>
	</TopPopup>
</template>
